import { render } from "./FormTabs.vue?vue&type=template&id=572fdaaa&scoped=true"
import script from "./FormTabs.vue?vue&type=script&lang=js"
export * from "./FormTabs.vue?vue&type=script&lang=js"

import "./FormTabs.vue?vue&type=style&index=0&id=572fdaaa&lang=scss&scoped=true"

import exportComponent from "/var/www/pointra/manager/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-572fdaaa"],['__file',"FormTabs.vue"]])

export default __exports__